import { combineReducers } from 'redux'

import order from './reducers/order'
import publicData from './reducers/public'
import auth from './reducers/auth'
import user from './reducers/user'
import mealDetail from './reducers/mealDetail'

const rootReducer = combineReducers({
  order,
  publicData,
  auth,
  user,
  mealDetail
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/rootReducer.js